import { render } from "./WorksSwipe.vue?vue&type=template&id=1ecfca3f&scoped=true"
import script from "./WorksSwipe.vue?vue&type=script&lang=js"
export * from "./WorksSwipe.vue?vue&type=script&lang=js"

import "./WorksSwipe.vue?vue&type=style&index=0&id=1ecfca3f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1ecfca3f"

export default script